// @flow

import React, {Component} from 'react';
import {connect} from 'react-redux';
import Hidden from '@material-ui/core/Hidden';
import queryString from 'query-string';
import mapKeys from 'lodash/mapKeys';
import {type SearchSketchOrder} from '../../typeDefinitions/searchSketchOrder';
import {type UserRoles} from '../../typeDefinitions/userRoles';
import {type SketchOrder} from '../../typeDefinitions/sketchOrder';
import { mapSearchSketchOrderToSketchOrder } from "../../lib/sketchOrderHelpers";
import SketchOrderTable from '../../components/SketchOrderTable';
import SketchOrderList from '../../components/SketchOrderList';
import { searchSketchOrders } from "../../actions/searchSketchOrdersActions";

type Location = {
    search: string,
};

type Props = {
    dispatch: Function,
    sketchOrders: Array<SearchSketchOrder>,
    totalResults: number,
    currentPage: number,
    totalPages: number,
    isFetching: boolean,
    currentUserRoles: UserRoles,
    location: Location,
    currentUserName: string,
};

export class SearchSketchOrders extends Component<Props> {
    async componentDidMount() {
        await this.getSketchOrders();
    }

    async componentDidUpdate(prevProps: Props) {
        if (prevProps.location.search !== this.props.location.search) {
            await this.getSketchOrders();
        }
    }

    getSketchOrders = async (page: number = 1): Promise<void> => {
        const queryParams = queryString.parse(this.props.location.search);
        const { q: search } = queryParams;

        await this.props.dispatch(searchSketchOrders(search, page));
    };

    getNextPage = async (): Promise<void> => {
        const nextPage: number = this.props.currentPage + 1;
        await this.getSketchOrders(nextPage);
    };

    getPrevPage = async (): Promise<void> => {
        const prevPage: number = this.props.currentPage - 1;
        await this.getSketchOrders(prevPage);
    };

    render() {
        const isSketchOsAdmin = (this.props.currentUserRoles.isAdmin || this.props.currentUserRoles.isSketchOsAdmin);

        const sketchOrders: Array<SketchOrder> = this.props.sketchOrders.map(mapSearchSketchOrderToSketchOrder);
        const sketchOrderIds = sketchOrders.map(order => order.id);

        return (
            <div>
                <Hidden smDown>
                    <SketchOrderTable
                        sketchOrders={mapKeys(sketchOrders, 'id')}
                        sketchOrderIds={sketchOrderIds}
                        totalOrders={this.props.totalResults}
                        currentPage={this.props.currentPage}
                        totalPages={this.props.totalPages}
                        onPrevPageClick={this.getPrevPage}
                        onNextPageClick={this.getNextPage}
                        showOrganizationName={isSketchOsAdmin}
                        showProjectName={isSketchOsAdmin}
                        showStatus
                        showOwner={isSketchOsAdmin}
                        showAddress={isSketchOsAdmin}
                        showRequester={isSketchOsAdmin}
                        showLinksToSupportDashboard={this.props.currentUserRoles.isAdmin}
                        showLastUpdatedAtTime
                        isFetching={this.props.isFetching}
                        currentUserName={this.props.currentUserName}
                    />
                </Hidden>
                <Hidden mdUp>
                    <SketchOrderList
                        sketchOrders={sketchOrders}
                        sketchOrderIds={sketchOrderIds}
                        totalOrders={this.props.totalResults}
                        currentPage={this.props.currentPage}
                        totalPages={this.props.totalPages}
                        onPrevPageClick={this.getPrevPage}
                        onNextPageClick={this.getNextPage}
                        showOrganizationName={isSketchOsAdmin}
                        showStatus
                        isFetching={this.props.isFetching}
                    />
                </Hidden>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { searchSketchOrders: searchSketchOrdersStore, currentUserRoles, currentUser } = state;
    const { 
        sketchOrders,
        isFetching,
        totalResults,
        totalPages,
        currentPage,
    } = searchSketchOrdersStore;
    const { userName: currentUserName } = currentUser;

    return {
        sketchOrders,
        isFetching,
        totalResults,
        totalPages,
        currentPage,
        currentUserRoles,
        currentUserName,
    };
};
 
export default connect(mapStateToProps)(SearchSketchOrders);
